<template>
  <section>
    <!-- form-geral -->

    <form @submit.prevent="getMarcas(1)">
      <div class="card card_border">
        <div class="cards__heading">
          <h3>Pesquisa <span>...</span></h3>
        </div>
        <div class="card-body">
          <div class="form-row">
            <div class="form-group col-md-12">
              
              <label for="inputID4" class="input__label"
                >ID</label
              >
              <input
                type="text"
                class="form-control input-style"
                name="id"
                v-model="paramsSearch.id"
                placeholder="ID"
              />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              
              <label for="inputDescricao4" class="input__label"
                >Descricao</label
              >
              <input
                type="text"
                class="form-control input-style"
                name="descricao"
                v-model="paramsSearch.descricao"
                placeholder="Descricao"
              />
            </div>
          </div>
        </div>
        <div class="card-footer">
          <button type="submit" class="btn btn-primary btn-style">
            Pesquisar
          </button>
        </div>
      </div>
    </form>
    <!-- /form-geral -->

    <!-- data tables -->
    <Table :fields="fields" :rowsData="marcas" :meta="meta" :getData="getMarcas" :optionsEdit="deleteMarca" />
    <!-- //data tables -->
  </section>
</template>

<script>

import { onMounted } from "vue";

import Table from "@/components/Table.vue";
import useCommon from "@/common";
import useMarca from '@/composables/Marca';

export default {
  components: {
    Table,
  },
  setup() {
    const { openToast } = useCommon();
    const { status, message, error, meta, paramsSearch, marcas, getMarcas, destroyMarca } = useMarca();

    const showMessages = () => {
      if(status.value){
        openToast(message.value, 'success');
      }else{
        openToast(error.value, 'error');
      }
    };

    const deleteMarca = async (id) => {
      if (!window.confirm("Confirm??")) {
        return;
      }

      await destroyMarca(id);      
      showMessages();
      await getMarcas();
    };

    onMounted(function () {
      getMarcas();
    });
    
    const fields = ["id", "descricao"];

    return {
      paramsSearch,
      meta,
      marcas,
      deleteMarca,
      getMarcas,
      fields
    };
  },
};
</script>
